
<template>

<el-tabs v-model="activeName" type="card" >
    <el-tab-pane label="二手车" name="first">
        <intranet-goods-list ref="clue-management" :businessId="businessId" type="二手车"></intranet-goods-list>
    </el-tab-pane>
</el-tabs>

</template>

<script>
import intranetGoodsList from './children/intranetGoodsList'
export default {
  name: 'plus-intranet-goods-tab-index',
  data () {
    return {
      businessId: null,
      isAdmin: false,
      activeName: 'first'
    }
  },
  created: function () {
    let params = this.$route.params

    this.businessId = params.businessId
  },
  activated: function () {
    let params = this.$route.params

    this.businessId = params.businessId
  },
  mounted: function () {
  },
  components: {
    intranetGoodsList
  },
  methods: {}
}

</script>
